/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Lazy_Bee_CutInputs */

const fr_agent_lazy_bee_cut = /** @type {(inputs: Agent_Lazy_Bee_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser`)
};

/**

* @param {Agent_Lazy_Bee_CutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const agent_lazy_bee_cut = /** @type {((inputs?: Agent_Lazy_Bee_CutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Lazy_Bee_CutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_agent_lazy_bee_cut(inputs)
});